import React from 'react';
import imgResolver from '../utils/img-resolver';

class RatePeopleInfo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showInfo: true
        }
    }

    toggleInfo() {
        this.setState({
            showInfo: !this.state.showInfo
        });
    }

    render () {
        return (
            <div className={"info-box" + (this.state.showInfo ? " active" : "")}>
                <button className="close" onClick={this.toggleInfo.bind(this)}><span>&times;</span></button>
                <div className="info-content flag">
                    <div className="flag-left">
                        <img className="info-img" src={require('../styles/images/icon_thumbs_up.svg')} />
                    </div>
                    <div className="body">
                        <h2>Rate people</h2>
                        <p>If you are happy with the performance and would recommend this person please give your like here. If the person didn't show up without acceptable reason please mark the NoShow. If you don't want to work with this person in the future please mark banned. All ratings are private.</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default RatePeopleInfo;



/** WEBPACK FOOTER **
 ** ./app/src/components/RatePeopleInfo.js
 **/